import { render } from "./SectionTitle.vue?vue&type=template&id=2ab4a411"
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"
script.render = render

export default script